<template>
  <v-navigation-drawer
    v-model="show"
    v-lock-scroll="show"
    app
    temporary
    right
    tag="aside"
    width="800px"
    class="right-side-panel"
  >
    <panel-header :show.sync="show">FAQ</panel-header>

    <cg-loader v-if="loading" />

    <div v-else class="right-side-panel__content-wrapper">
      <cg-chip-group
        v-if="availableTags.length > 1"
        v-model="selectedTag"
        :chipsData="availableTags"
        class="campaign-faq-panel__tags"
      />

      <div v-if="!filteredItems.length" class="campaign-faq-panel__empty">
        {{ loadFailed ? 'We couldn\'t load the FAQ right now. Please try again later.' : 'No FAQ available yet.' }}
      </div>

      <div v-else class="campaign-faq-panel__items">
        <campaign-faq-item
          v-for="item in filteredItems"
          :key="item.id"
          :title="item.title"
          :content="item.content"
          :video-link="item.video_url"
        />
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import ApiCms from '@/axios/apiCMS'
import panelVModel from '@/mixins/panelVModel'

import { CgLoader, CgChipGroup } from '@corporategiftcom/design-system'
import PanelHeader from '@/components/PanelHeader.vue'
import CampaignFaqItem from './CreateCampaignFaqItem.vue'

export default {
  name: 'CreateCampaignFaqPanel',
  mixins: [panelVModel],
  components: {
    CgLoader,
    PanelHeader,
    CgChipGroup,
    CampaignFaqItem,
  },
  data: () => ({
    loading: false,
    loadFailed: false,
    data: [],
    selectedTag: 'All',
  }),
  computed: {
    availableTags () {
      const faqTags = [...new Set(this.data.flatMap((faqItem) => faqItem.tags))]
      return ['All', ...faqTags]
    },
    filteredItems () {
      const { selectedTag, data } = this

      if (selectedTag === 'All') { return data }
      return data.filter((faqItem) => faqItem.tags.includes(selectedTag))
    },
  },
  watch: {
    show: {
      immediate: true,
      handler (val) {
        if (val && !this.data.length && !this.loading) { this.fetchFaq() }
      },
    },
  },
  methods: {
    fetchFaq () {
      this.loading = true
      this.loadFailed = false

      // populate=* works on both Strapi v4 (`faq` relation, `attributes` wrapper)
      // and v5 (`campaign_faq_tags` relation, flat entries)
      ApiCms.get('/campaign-faqs?populate=*&pagination[limit]=1000')
        .then(({ data }) => {
          this.data = data.map((faqItem) => {
            const item = faqItem.attributes ?? faqItem
            const tags = item.campaign_faq_tags
              ?? [item.faq?.data?.attributes ?? item.faq].filter(Boolean)

            return {
              id: faqItem.id,
              title: item.title,
              content: item.content,
              video_url: item.video_url ?? null,
              tags: tags.map((tag) => tag?.Title).filter(Boolean),
            }
          })
        })
        .catch(() => (this.loadFailed = true))
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/common/right-side-panel.scss';

.campaign-faq-panel {
  &__items {
    gap: 16px;
    display: flex;
    flex-direction: column;
  }

  &__empty {
    font-family: 'Lato-Regular', sans-serif;
    font-size: 15px;
    line-height: 22px;
    color: #95979d;
  }

  &__tags::v-deep .cg-chip__content {
    font-family: 'Lato-Regular', sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
  }
}
</style>
